import image1 from "../images/ImageList/ImageList1.jpg";
import image2 from "../images/ImageList/ImageList2.jpg";
import image3 from "../images/ImageList/ImageList3.jpg";

const objectArray = [
  {
    image: image1,
    title: "Explore",
    content:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },
  {
    image: image2,
    title: "Discover",
    content:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },
  {
    image: image3,
    title: "Indulge",
    content:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  },
];

export default objectArray;
